var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFAB)?_c('v-btn',{staticClass:"mb-4 mr-4",staticStyle:{"z-index":"1000"},attrs:{"elevation":"24","fab":"","fixed":"","bottom":"","right":"","color":"warning"},on:{"click":function($event){return _vm.exportDiagnostics()}}},[_c('v-icon',[_vm._v("mdi-progress-wrench")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }